import { DeviceModel, DeviceStatus } from '@/features/devices/types/types'
import ConnectIcon from '@/shared/assets/icons/connectIcon.svg?react'
import EditIcon from '@/shared/assets/icons/edit.svg?react'
import { BaseButton, BaseCard, BaseCheckbox } from '@/shared/components'
import { DeviceState } from '@/shared/components/DeviceState/DeviceState'
import { DeviceIcon } from '@/shared/components/icons/DeviceIcon'
import { ItemLayout } from '@/shared/components/ItemLayout/ItemLayout'
import { formatDate } from '@/shared/lib/date'
import { Link } from 'react-router-dom'
import { DeviceStatusIcons } from '../../types/constants'

type Props = {
  device: DeviceModel
  isSelected: boolean
  onSelect: (selected: boolean) => void
  connectNewDevice: (key: string, qrCode: string) => void
  onEdit: (id: string) => void
}
export const MobileBlock = ({ device, isSelected, onSelect, onEdit, connectNewDevice }: Props) => {
  const formattedDate =
    !device.lastPingedAt || device.lastPingedAt === 'Нет данных'
      ? 'Нет данных'
      : formatDate(device.lastPingedAt, 'long')

  const handleEdit = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    event.preventDefault()
    onEdit(device.id)
  }

  const handleConnect = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    event.preventDefault()
    connectNewDevice(device.key, device.qrCode)
  }

  return (
    <div className="md:hidden mb-4 last:mb-0 w-full">
      <Link to={`${device.id}`} className="w-full no-underline">
        <BaseCard radius="md" className="w-full text-sm">
          <div className="pb-6">
            <BaseCheckbox checked={isSelected} onChange={onSelect} />
          </div>
          <div className="flex flex-col gap-4">
            <div>
              <div className="flex justify-between items-center">
                <ItemLayout
                  icon={<DeviceIcon status={DeviceStatusIcons[device.status]} />}
                  title={device.name}
                  subtitle={device.id}
                  subtitleClasses="w-[250px] truncate"
                />
                <BaseButton
                  onClick={handleEdit}
                  variant="ghost"
                  icon={<EditIcon className="text-text-secondary" />}
                  padding="none"
                ></BaseButton>
              </div>
              {device.deviceStatus === DeviceStatus.NotConnected && (
                <BaseButton
                  onClick={handleConnect}
                  variant="primary"
                  padding="none"
                  radius="md"
                  className="!bg-light-purple hover:!bg-light-purple-hover mt-[30px] w-full !text-primary text-base"
                  iconPosition="left"
                  icon={<ConnectIcon />}
                >
                  Подключить
                </BaseButton>
              )}
            </div>
            {device.deviceStatus !== DeviceStatus.NotConnected && (
              <>
                <div className="flex flex-col gap-2">
                  <span className="text-text-secondary">Состояние</span>
                  <DeviceState
                    status={device.status}
                    direction="row"
                    battery={device.battery}
                    network={device.network}
                  />
                </div>
                <div className="flex flex-col gap-2">
                  <span className="text-text-secondary">Последняя активность</span>
                  <div className="flex gap-1 font-klein font-medium">
                    <span>Запущено:</span>
                    <span>{formattedDate}</span>
                  </div>
                </div>
                <div className="flex flex-col gap-2">
                  <span className="text-text-secondary">Реквизиты</span>
                  <span className="font-klein font-medium">0</span>
                </div>
              </>
            )}
          </div>
        </BaseCard>
      </Link>
    </div>
  )
}
